import React from "react";
import "./App.css";
import "react-toastify/dist/ReactToastify.css";
import { Header } from "./components/Header/Header.jsx";
import { Footer } from "./components/Footer/Footer.jsx";
import { AppRoutes } from "./routes/AppRoutes.jsx";
import { useLocation } from "react-router-dom";
import { ToastContainer } from "react-toastify";

const App = () => {
  const path = useLocation();
  return (
    <>
      <div className="fullscreen-layout">
        <Header path={path.pathname} />
        <main>
          <AppRoutes />
        </main>
        <Footer />
      </div>

      <ToastContainer
        position="bottom-right"
        autoClose={5000}
        hideProgressBar={false}
        newestOnTop={false}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
      />
    </>
  );
};

export default App;
